import {Observable} from 'rxjs'
import {buffer, throttleTime} from 'rxjs/operators'

export function bufferThrottleTime(millis: number, leading = true, trailing = true) {
	return function <T>(source$: Observable<T>) {
		return source$.pipe(
			buffer(
				source$.pipe(
					throttleTime(millis, undefined, {leading, trailing}),
				),
			),
		)
	}
}